<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-card-title>
        <span class="text-body-1 primary--text">Editar Empresa</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <validation-alert :validationErrors="validationErrors" />
          <v-form ref="form" v-model="isValidFormDialog" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.name"
                  :rules="nameRules"
                  label="Nombre"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.society"
                  :rules="societyRules"
                  label="Sociedad"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-switch v-model="editedItem.active" label="Estado"></v-switch>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="close()"> Cancelar </v-btn>
        <v-btn
          color="blue"
          :loading="isLoading"
          :disabled="isLoading"
          text
          @click="save()"
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ValidationAlert from "@/components/global/ValidationAlert.vue";
import { $EventBus } from "@/main";
export default {
  name: "EditCompanyDialog",

  props: {
    company: Object,
  },

  data: () => ({
    dialog: false,
    isValidFormDialog: false,
    isLoading: false,
    nameRules: [(v) => !!v || "Campo requerido"],
    societyRules: [(v) => !!v || "Campo requerido"],
    editedItem: {
      id: "",
      name: "",
      society: "",
      active: null,
    },
    defaultItem: {
      id: "",
      name: "",
      society: "",
      active: null,
    },
  }),

  computed: {
    validationErrors() {
      return this.$store.getters["companies/getValidationErrors"];
    },
  },

  watch: {
    company(val) {
      if (val && val.name) {
        this.dialog = true;
        this.editedItem = val;
      }
    },
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.$store.dispatch("companies/cleanValidationErrors");
        this.$refs.form.resetValidation();
      });
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        let data = {
          id: this.editedItem.id,
          name: this.editedItem.name,
          society: this.editedItem.society,
          active: this.editedItem.active,
        };
        try {
          await this.$store.dispatch("companies/updateCompany", data);
          $EventBus.$emit("showSnack", {
            color: "green",
            text: "Empresa actualizada",
          });
          this.$emit("resetFilter");
          this.close();
        } catch (error) {}
        this.isLoading = false;
      }
    },
  },

  components: {
    ValidationAlert,
  },
};
</script>
